import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import { bool, func, instanceOf, string } from "prop-types";
import React from "react";
import { BillItem, BillingTitleColumns } from "./index";

export const MultipleBill = ({ billingList, isDesktop, billToPay, setBillToPay, paymentType }) => {
    const billColumns = billingList[0].details.map((detail) => detail.label);

    return (
        <ProductList
            fetchingWithPreviousData
            items={billingList || []}
            noDataText="global.no.results"
            renderItem={(item) => (
                <GridTable.Container key={`service-bill-${item.hash}`} className={!isDesktop && "box box-shadow"}>
                    <BillItem
                        key={`transaction-${item.hash}`}
                        bill={item}
                        billToPay={billToPay}
                        setBillToPay={setBillToPay}
                        isDesktop={isDesktop}
                        paymentType={paymentType}
                    />
                </GridTable.Container>
            )}>
            {(listItem) => (
                <GridTable className="d-flex justify-content-between my-6 flex-auto">
                    {isDesktop && (
                        <GridTable.Header>
                            <GridTable.Container columns={billColumns.length + 1} rows={1}>
                                <BillingTitleColumns billColumns={billColumns} />
                            </GridTable.Container>
                        </GridTable.Header>
                    )}
                    <GridTable.Body>{listItem}</GridTable.Body>
                </GridTable>
            )}
        </ProductList>
    );
};

MultipleBill.propTypes = {
    billingList: instanceOf(Array).isRequired,
    isDesktop: bool.isRequired,
    setBillToPay: func.isRequired,
    billToPay: instanceOf(Array).isRequired,
    paymentType: string.isRequired,
};

export default MultipleBill;
